/** Neutral slate palette — clean canvas, white surfaces, blue for CTAs only. */
export const designTokens = {
  /** Clean neutral slate page canvas */
  bgApp: "#F8FAFC",
  /** Cards, sidebar, panels, header */
  bgSurface: "#FFFFFF",
  /** Table headers, nested panels, hover / active washes */
  bgSubtle: "#F1F5F9",
  /** Deep slate charcoal — high-contrast body text */
  textPrimary: "#1E293B",
  /** Secondary labels — WCAG AA on white */
  textMuted: "#475569",
  /** Delicate dividers and card borders */
  borderLight: "#E2E8F0",
  /** Primary CTAs and active pagination only */
  primaryBrand: "#2563EB",
  primaryHover: "#1D4ED8",
  /** Neutral wash for selected rows / active (non-blue) */
  primarySoft: "#F1F5F9",
} as const;

export type DesignToken = keyof typeof designTokens;

/** Match Buy page h1 — Lexend 18/700, slate charcoal */
export const pageTitleSx = {
  fontFamily: '"Lexend", sans-serif',
  fontWeight: 700,
  fontSize: 18,
  letterSpacing: "-0.01em",
  color: "#1E293B",
  lineHeight: 1.2,
} as const;
